export default "__VITE_ASSET__Bxlu2i1F__"